export const CONTACT_EMAIL = "easysweetchat@gmail.com";
export const SITE = "easysweetchat.com";
export const RETENTION_DAYS = 180;
export const TERMS_VERSION = "2026-06";
export const AGE_KEY = `esc_terms_${TERMS_VERSION}`;
export const COOKIE_KEY = "esc_cookie_consent";

export const openCookieSettings = () => window.dispatchEvent(new Event("esc-open-cookies"));
